/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Canceldeal_Cancelled2Inputs */

const en_coinvestments_canceldeal_cancelled2 = /** @type {(inputs: Coinvestments_Canceldeal_Cancelled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelled`)
};

/**
* | output |
* | --- |
* | "Cancelled" |
*
* @param {Coinvestments_Canceldeal_Cancelled2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_canceldeal_cancelled2 = /** @type {((inputs?: Coinvestments_Canceldeal_Cancelled2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Canceldeal_Cancelled2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_canceldeal_cancelled2(inputs)
});
export { coinvestments_canceldeal_cancelled2 as "coInvestments_cancelDeal_cancelled" }